import { Component, OnInit, Input, inject } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { ModalComponent } from '../../../../shared/components/modal.component';
import { EventManager } from '../../../../core';
@Component({
  selector: 'app-check-change-product-popup',
  templateUrl: './check-change-product-popup.component.html',
  styleUrls: ['./check-change-product-popup.component.scss']
})
export class CheckChangeProductPopupComponent extends ModalComponent implements OnInit {
  @Input() properties: any[] = [];
  readonly nzModalData: any = inject(NZ_MODAL_DATA);
  constructor(
    public eventManger: EventManager,
  ) { 
    super(eventManger);
  }

  ngOnInit() {
    super.ngOnInit();
    this.properties = this.properties.map((property) => {
      const find: any = KEY_TITLE.find(item => item.key === property.key) || {};
      property.title = find.value || property.key;
      return property;
    })
  }
}
const KEY_TITLE = [
  { key: 'code', value: 'Mã' },
  { key: 'name', value: 'Tên' },
  { key: 'nameEn', value: 'Tên Tiếng Anh' },
  { key: 'tradeCode', value: 'Mã giao dịch' },
  { key: 'vsdCode', value: 'Mã phí VSD' },
  { key: 'issuePrice', value: 'Giá' },
  { key: 'expectedReturn', value: 'Lợi nhuận kỳ vọng (%)' },
  { key: 'managementFee', value: 'Phí quản lý (%/năm) ' },
  { key: 'buyMinValue', value: 'Số tiền mua tối thiểu' },
  { key: 'buyMaxValue', value: 'Số tiền mua tối đa' },
  { key: 'performanceFee', value: 'Phí thành tích' },
  { key: 'sellMin', value: 'Số lượng bán tối thiểu' },
  { key: 'transferSellMin ', value: 'Số lượng chuyển đổi bán tối thiểu' },
  { key: 'isOnlySellMinNotSellAll', value: 'Chỉ bán tối thiểu ko bán hết' },
  { key: 'closedBankNote', value: 'Thời điểm ghi nhận tiền vào quỹ' },
  { key: 'closedOrderBookAt', value: 'Thời điểm đóng sổ lệnh' },
  { key: 'holdingMin', value: 'Số lượng nắm giữ tối thiểu' },
  { key: 'completeTransactionDuration', value: 'Thời hạn thanh toán bán' },
  { key: 'issueValue', value: 'Tổng giá trị phát hành' },
  { key: 'description', value: 'Mô tả' },
  { key: 'descriptionEn', value: 'Mô tả tiếng Anh' },
  { key: 'website', value: 'Website báo cáo hoạt động quỹ' },
  { key: 'fundTypeId', value: 'Kiểu quỹ' },
  { key: 'fundAssetTypeId', value: 'Loại quỹ' },
  { key: 'riskNumber', value: 'Chỉ số rủi ro' },
  { key: 'productTransactionDateList', value: 'Ngày duyệt giao dịch' },
  { key: 'assetAllocation1Id', value: 'Tài sản đầu tư (thứ nhất)' },
  { key: 'assetAllocation2Id', value: 'Tài sản đầu tư (thứ hai)' },
  { key: 'riskLevelId', value: 'Mức độ rủi ro' },
  { key: 'transactionDates', value: 'Ngày duyệt giao dịch' },
  { key: 'closedOrderBookShiftDay', value: 'Ngày đóng sổ lệnh' },
  { key: 'endIssueAt', value: 'Ngày kết thúc phát hành' },
  { key: 'sipCode', value: 'Mã Ship' },
  { key: 'feeBuys', value: 'Phí phát hành' },
  { key: 'feeSells', value: 'Phí bán' },
  { key: 'feePenalty', value: 'Phí rời SIP trước hạn' },
  { key: 'vsdFeeId', value: 'Mã phí VSD' },
  { key: 'hsbcCode', value: 'Mã phí HSBC' },
  { key: 'minCycleLength', value: 'Thời gian đầu tư liên tục tối thiểu(tháng)' },
  { key: 'maxCycleLength', value: 'Thời gian đầu tư tối đa' },
  { key: 'maxContinuousNoninvestmentCycle', value: 'Số kỳ liên tục không đầu tư' },
  { key: 'lastTransferDay', value: 'Ngày thanh toán chậm nhất' },
  { key: 'isFeeFromFirstTransactionBreakSip', value: 'Tính phí theo kỳ giao dịch đầu tiên (rời SIP)' },
  { key: 'bank-name', value: 'Tên ngân hàng' },
  { key: 'bank-number', value: 'Mã ngân hàng' },
  { key: 'bank-branch', value: 'Chi nhánh' },
  { key: 'bank-bankId', value: 'Ngân hàng' },
  { key: 'customField', value: 'Custom Field' },
  { key: 'customValue', value: 'Custom Value' },
  { key: 'ipoEndTime', value: 'Giờ kết thúc IPO' },
  { key: 'ipoStartTime', value: 'Giờ bắt đầu IPO' },
  { key: 'endIPODate', value: 'Ngày kết thúc IPO' },
  { key: 'startIPODate', value: 'Ngày bắt đầu IPO' },
  { key: 'surveyIpoTemplate', value: 'Survey IPO Template' },
  { key: 'bank-comment', value: 'Ghi chú chuyển khoản' },
  { key: 'bank-bankCode', value: 'Mã ngân hàng (chuyển tiền reward)' },
  { key: 'allocationDuration', value: 'Số ngày phân bổ' },
  { key: 'buyCommissionFee', value: 'Phí Hoa Hồng Mua' },
  { key: 'trailerFee', value: 'Phí Duy Trì' },
  { key: 'transferBuyCommissionFee', value: 'Phí Hoa Hồng Chuyển Đổi' },
  { key: 'isReconcileByTransferAmount', value: 'Khớp theo số tiền chuyển khoản' },
  { key: '', value: '' },
]